import React from 'react';
import LayoutContext from '../LayoutContext';
import { useConfiguredCounts } from '../../Router/onboarding/hooks';

export type OnboardingPreLaunchModalContextType = {
  visible: boolean;
  openModal: () => void;
  closeModal: () => void;
  configuredCount?: number;
  totalCount?: number;
};

const OnboardingPreLaunchModalContext =
  React.createContext<OnboardingPreLaunchModalContextType>(null);

export const OnboardingPreLaunchModalContextProvider: React.FC = ({
  children,
}) => {
  const { setChatVisibility } = React.useContext(LayoutContext);
  const [visible, setVisible] = React.useState(false);

  const { totalCount, configuredCount } = useConfiguredCounts();

  const memoizedValue = React.useMemo(() => {
    const openModal: OnboardingPreLaunchModalContextType['openModal'] = () => {
      setChatVisibility(false);
      setVisible(true);
    };

    const closeModal: OnboardingPreLaunchModalContextType['closeModal'] =
      () => {
        setChatVisibility(true);
        setVisible(false);
      };
    return {
      visible,
      openModal,
      closeModal,
      totalCount,
      configuredCount,
    };
  }, [configuredCount, setChatVisibility, totalCount, visible]);

  return (
    <OnboardingPreLaunchModalContext.Provider value={memoizedValue}>
      {children}
    </OnboardingPreLaunchModalContext.Provider>
  );
};

export default OnboardingPreLaunchModalContext;
